/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PointGeometry } from './PointGeometry';
import {
    PointGeometryFromJSON,
    PointGeometryFromJSONTyped,
    PointGeometryToJSON,
} from './PointGeometry';

/**
 * 
 * @export
 * @interface Bollard
 */
export interface Bollard {
    /**
     * 
     * @type {number}
     * @memberof Bollard
     */
    id?: number;
    /**
     * 
     * @type {PointGeometry}
     * @memberof Bollard
     */
    position?: PointGeometry;
}

/**
 * Check if a given object implements the Bollard interface.
 */
export function instanceOfBollard(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BollardFromJSON(json: any): Bollard {
    return BollardFromJSONTyped(json, false);
}

export function BollardFromJSONTyped(json: any, ignoreDiscriminator: boolean): Bollard {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'position': !exists(json, 'position') ? undefined : PointGeometryFromJSON(json['position']),
    };
}

export function BollardToJSON(value?: Bollard | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'position': PointGeometryToJSON(value.position),
    };
}

